import * as React from 'react'
import {Box} from "@mui/material";
import {formatPriceSymbol} from "@ui-seeker/utils";

import {NotAllowedBlock} from "@components";


export default function avgPriceColumn() {
    return {
        name: 'avgSkuPrice', label: 'Market Avg Price',
        options: {
            setCellHeaderProps: () => ({ sx: {
                    whiteSpace: 'pre-wrap',
                }}),
            customBodyRowRenderLite: (value, { currency }) => <Box sx={{ textAlign: 'center' }}>
                {!!value && formatPriceSymbol(value, currency, { displayZero: true })}
                {!value && <NotAllowedBlock />}
            </Box>
        }
    }
}